(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-jsqh-planner]').forEach((planner) => {
      if (planner.dataset.jsqhReady === 'true') return;
      const input = planner.querySelector('[data-jsqh-count]');
      const total = planner.querySelector('[data-jsqh-total]');
      const results = planner.querySelector('.jsqh-planner__results');
      const error = planner.querySelector('.jsqh-planner__error');
      const fallback = planner.querySelector('[data-jsqh-static]');
      if (!input || !total || !results || !error) return;
      if (!planner.dataset.countTemplate || !planner.dataset.boxTemplate) return;
      const section = planner.closest('.jsqh-section');
      const picks = Array.from(section ? section.querySelectorAll('[data-jsqh-plan-pack]') : []).map((pick) => {
        const button = pick.querySelector('[data-jsqh-plan-button]');
        const quantity = pick.querySelector('[data-jsqh-plan-quantity]');
        const summary = pick.querySelector('[data-jsqh-plan-summary]');
        const pack = Number(pick.dataset.jsqhPlanPack);
        const price = Number(pick.dataset.priceCents);
        const limit = Number(pick.dataset.maxPacks);
        if (!button || !quantity || !summary || !Number.isInteger(pack) || pack <= 0 || !Number.isFinite(price) || price < 0 || !Number.isInteger(limit)) return null;
        if (!pick.dataset.addOne || !pick.dataset.addMany || !pick.dataset.labelOne || !pick.dataset.labelMany || !pick.dataset.summaryOne || !pick.dataset.summaryMany || !pick.dataset.limitText || !pick.dataset.invalidText) return null;
        return {pick, button, quantity, summary, pack, price, limit};
      }).filter(Boolean);
      let money = null;
      try {
        money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: planner.dataset.currency});
      } catch {}
      const update = () => {
        const number = Number(input.value);
        const valid = input.value !== '' && input.checkValidity() && Number.isInteger(number) && number >= 1 && number <= 100;
        input.setAttribute('aria-invalid', valid ? 'false' : 'true');
        results.hidden = !valid;
        error.hidden = valid;
        picks.forEach(({pick, button, quantity, summary, pack, price, limit}) => {
          if (!valid) {
            button.disabled = true;
            button.textContent = pick.dataset.invalidText;
            button.setAttribute('aria-label', pick.dataset.invalidText);
            quantity.value = '1';
            summary.hidden = true;
            summary.textContent = '';
            return;
          }
          const count = Math.ceil(number * 44 / pack);
          const overLimit = limit >= 0 && count > limit;
          const key = count === 1 ? 'One' : 'Many';
          button.disabled = overLimit;
          button.textContent = overLimit ? pick.dataset.limitText : pick.dataset['add' + key].replace('__COUNT__', String(count));
          button.setAttribute('aria-label', overLimit ? pick.dataset.limitText : pick.dataset['label' + key].replace('__COUNT__', String(count)));
          quantity.value = overLimit ? '1' : String(count);
          summary.hidden = !overLimit && !money;
          summary.textContent = overLimit ? pick.dataset.limitText : money ? pick.dataset['summary' + key].replace('__COUNT__', String(count)).replace('__PRICE__', money.format(count * price / 100)) : '';
        });
        if (!valid) return;
        const quantity = number * 44;
        total.textContent = planner.dataset.countTemplate.replace('__COUNT__', String(quantity));
        planner.querySelectorAll('[data-jsqh-boxes]').forEach((box) => {
          const pack = Number(box.dataset.jsqhBoxes);
          box.textContent = planner.dataset.boxTemplate.replace('__COUNT__', String(Math.ceil(quantity / pack)));
        });
      };
      input.addEventListener('input', update);
      update();
      planner.dataset.jsqhReady = 'true';
      input.disabled = false;
      if (fallback) fallback.hidden = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
